<template>
  <Dialog
    v-model:visible="isVisible"
    :modal="true"
    class="col-12 md:col-6"
    @show="onShow"
  >
    <template #header>
      <h3>{{ $t('lineidpage.dialog.import.header') }}</h3>
    </template>

    <div class="confirmation-content">
      <label for="lineIdFile">{{ $t('lineidpage.dialog.import.uploadlabel') }}</label>
      <input
        id="lineIdFile"
        class="block pt-2"
        type="file"
        accept=".csv"
        @change="onChooseFile($event)"
      >
      <Message
        v-if="errorMsg"
        severity="error"
        :closable="false"
      >
        {{ errorMsg }}
      </Message>
    </div>
    <template #footer>
      <Button
        :label="$t('lineidpage.dialog.confirmButton')"
        icon="pi pi-check"
        class="p-button-rounded p-button-outlined"
        :disabled="!file"
        :loading="loading"
        @click="importFile"
      />
    </template>
  </Dialog>
</template>

<script>
import Dialog from "primevue/dialog";
import Button from "primevue/button";
import Message from "primevue/message";

export default {
  name: 'LineIdImportDialog',
  components: {Dialog, Button, Message},
  props: {
    lineIds: {
      type: Array,
      default: () => []
    },
    visible: {
      type: Boolean,
      required: true
    }
  },
  emits: ['update:visible', 'import'],
  data() {
    return {
      file: null,
      loading: false,
      errorMsg: ''
    }
  },
  computed: {
    isVisible: {
      get() {
        return this.visible
      },
      set(value) {
        this.$emit('update:visible', value)
      }
    }
  },
  methods: {
    onShow() {
      this.file = null;
      this.errorMsg = '';
    },
    onChooseFile(event) {
      this.file = event.target.files[0];
    },
    close() {
      this.isVisible = false;
    },
    async importFile() {
      this.loading = true;
      this.errorMsg = '';

      try {
        const result = await this.$lineIdService.import(this.file);
        if (result) {
          this.$emit('import');
          this.$emitter.emit('toast', {severity: 'success', message: 'lineidpage.dialog.import.success'})
          this.close();
        } else {
          this.errorMsg = this.$t('lineidpage.dialog.import.invalid');
        }
      } catch (e) {
        this.errorMsg = this.$t('lineidpage.dialog.import.error');
      } finally {
        this.loading = false;
      }

    }
  }
}
</script>
<style>

</style>
